import { Tooltip } from "@mui/material";
import styles from "./m3.module.css";

const TONE_CLASSES = {
  success: styles.badgeSuccess,
  warning: styles.badgeWarning,
  error: styles.badgeError,
  info: styles.badgeInfo,
  primary: styles.badgePrimary,
  tertiary: styles.badgeTertiary,
  neutral: styles.badgeNeutral,
};

/**
 * Material 3 compact status badge.
 * Ideal for AG Grid cells, table metadata, and status tags.
 *
 * @param {"success"|"warning"|"error"|"info"|"primary"|"tertiary"|"neutral"} tone
 * @param {"sm"|"md"} size - default "md" (24px height), "sm" (20px height)
 * @param {boolean} dot - renders a small colored circle indicator
 * @param {React.ReactNode} icon - optional leading icon
 * @param {string} tooltip
 */
const M3Badge = ({
  children,
  tone = "neutral",
  size = "md",
  dot = false,
  icon,
  tooltip,
  className = "",
  style,
}) => {
  const toneClass = TONE_CLASSES[tone] || styles.badgeNeutral;
  const sizeClass = size === "sm" ? styles.badgeSm : "";

  const content = (
    <span className={`${styles.badge} ${toneClass} ${sizeClass} ${className}`} style={style}>
      {dot && <span className={styles.badgeDot} />}
      {icon && <span style={{ display: "inline-flex", fontSize: size === "sm" ? 12 : 14 }}>{icon}</span>}
      {children}
    </span>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default M3Badge;
